export default __webpack_public_path__ + "static/media/template5.60366651.png";